import classNames from 'classnames';
import { root } from './FadeContainer.css';

export interface FadeContainerProps {
  children?: React.ReactNode;
  className?: string;
  noFadeLeft?: boolean;
  noFadeRight?: boolean;
}

export const FadeContainer = (props: FadeContainerProps) => {
  const { children, className, noFadeLeft, noFadeRight, ...rest } = props;

  return (
    <div
      className={classNames(
        className,
        root({ left: !noFadeLeft, right: !noFadeRight }),
      )}
      {...rest}
    >
      {children}
    </div>
  );
};
